const messages = {
  title: "Welkom bij BRIDGESTONE <span class='text-danger'>PLUS</span>",
  description:
    "Log in met uw e-mailadres en wachtwoord.<br/><br/><b>Bent u nieuw hier?</b><br /><br />Maak dan eerst uw nieuwe gebruikersaccount aan met de functie AANMELDEN.<br /><br />U wordt daarna automatisch ingelogd.<br /><br />Heeft u hulp nodig? Neem dan contact met ons op: plus-nl&#64;bridgestone.eu",
  info: "",
  buttons: {
    action: "Aanmelden",
    back: "Verder in het Nederlands",
    changeLanguage: "Taal wijzigen",
    start: "Nederlands",
  },
  languageSelect: {
    label: "Taalkeuze",
    description: "Selecteer een taal om verder te gaan",
    start: {
      nlBE: "Nederlands",
      frBE: "Français",
    },
  },
};

export default {
  messages,
};
